import { render, staticRenderFns } from "./PdfReader.vue?vue&type=template&id=45c995a8"
import script from "./PdfReader.vue?vue&type=script&lang=js"
export * from "./PdfReader.vue?vue&type=script&lang=js"
import style0 from "./PdfReader.vue?vue&type=style&index=0&id=45c995a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports